export const getTeleportId = (id: string) => `vue-teleport-target-${id}`.replace(/=/g, '');
